import apiUtil, { throwApiError } from '~/utils/apiUtils'

const { get, post } = apiUtil()

class JobDescriptionAPI {
  constructor() {}

  // Generate a job description for a position
  async generateJobDescription(positionId: string): Promise<string> {
    try {
      const response = await get(`/job-description/generate/${positionId}`)

      if (!response.ok) {
        await throwApiError(response)
      }

      const json = await response.json()
      return json.jobDescription
    } catch (error) {
      console.error('Error generating job description:', error)
      throw error
    }
  }

  // Save a job description for a position
  async saveJobDescription(positionId: string, jobDescription: string): Promise<void> {
    try {
      const response = await post(`/job-description/save/${positionId}`, {
        jobDescription
      })

      if (!response.ok) {
        await throwApiError(response)
      }

      return await response.json()
    } catch (error) {
      console.error('Error saving job description:', error)
      throw error
    }
  }
}

const jobDescriptionApi = new JobDescriptionAPI()

export default jobDescriptionApi
